export default __webpack_public_path__ + "static/media/services1.a336529f.jpg";